import cx from 'clsx';
import { Text } from '@paylink/constants';
import { IPaymentForProps } from '@paylink/types';

import styles from './PaymentFor.module.scss';

const PaymentFor = ({ description, isMobile = false }: IPaymentForProps) => (
	<div
		className={cx(
			'd-flex flex-column border-radius2 gap1 ',
			{ p2: isMobile, p4: !isMobile },
			styles.payingForCard,
		)}
	>
		<span className={cx('medium h6 grey2 lhp135', styles.payingForLabel)}>
			{Text.PAYMENT_REQUEST_FOR}
		</span>
		<p className={cx('h5 lighter mt0 mb0 lhp135', styles.payingForText)}>
			{description}
		</p>
	</div>
);

export default PaymentFor;
